<template>
  <div v-if="data != undefined">
    <div :class="data.number % 2 == 0 ? 'Right' : 'Left'">
      <div
        :class="
          data.number % 2 == 0
            ? 'RightFrame1'
            : 'LeftFrame1'
        "
      >
        <img class="icon" :src="data.iconUrl" />
        <div class="name theme_accent80">{{ data.name }}</div>
        <div class="title theme_white">{{ data.title }}</div>
      </div>
      <div class="user">
        <img :src="data.userIconUrl + '/256'" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

export interface FriendInfoData {
  name: string
  title: string
  iconUrl: string
  userIconUrl: string
  number: number
}

@Component
export default class FriendInfo extends Vue {
  @Prop({ required: true })
  data: FriendInfoData | undefined
}
</script>

<style scoped>
.theme_accent80 {
  color: #C0B6FF;
}

.theme_white {
  color: #FFFFFF
}

.Right {
  position: relative;
  width: 254px;
  height: 60px;
  left: 90px;
  top: 20px;
  font-family: -apple-system, BlinkMacSystemFont;
}

.RightFrame1 {
  width: 174px;
  height: 50px;

  background: rgba(33, 33, 33, 0.8);

  flex: none;
  order: 0;
  flex-grow: 1;
}

.Right .name {
  position: absolute;
  width: 158px;
  left: 8px;
  top: 23px;

  font-weight: 600;
  font-size: 14px;
  line-height: 21px;

  text-align: right;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Right .title {
  position: absolute;
  width: 156px;
  left: 9px;
  top: 6px;

  font-weight: 300;
  font-size: 11px;
  line-height: 16px;

  text-align: right;
}

.Right .icon {
  position: absolute;
  width: 50px;
  height: 50px;
  left: 0px;
  top: 0px;
}

.Right .user {
  position: absolute;
  left: 174px;
  top: -30px;
  width: 80px;
  height: 80px;

  filter: drop-shadow(0px 0px 4px rgba(100, 100, 100, 0.2));
  background: #ffffff;
}

.Right .user img {
  position: absolute;
  left: 5px;
  top: 5px;
  width: 70px;
  height: 70px;
}

.Left {
  position: relative;
  width: 254px;
  height: 60px;
  left: 0px;
  top: 20px;
  font-family: -apple-system, BlinkMacSystemFont;
}

.LeftFrame1 {
  position: relative;
  width: 174px;
  height: 50px;
  left: 80px;
  top: 0px;

  background: rgba(33, 33, 33, 0.8);
}

.Left .name {
  position: absolute;
  max-width: 158px;
  left: 8px;
  top: 23px;

  font-weight: 600;
  font-size: 14px;
  line-height: 21px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Left .title {
  position: absolute;
  width: 156px;
  left: 9px;
  top: 6px;

  font-weight: 300;
  font-size: 11px;
  line-height: 16px;
}

.Left .icon {
  position: absolute;
  width: 50px;
  height: 50px;
  right: 0px;
  top: 0px;
}

.Left .user {
  position: absolute;
  left: 0px;
  top: -30px;
  width: 80px;
  height: 80px;

  filter: drop-shadow(0px 0px 4px rgba(100, 100, 100, 0.2));
  background-color: #ffffff;
}

.Left .user img {
  position: absolute;
  left: 5px;
  top: 5px;
  width: 70px;
  height: 70px;
}
</style>
